import React from 'react';

const TwoDoctors: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="5"
      d="M56 108V85.99C56 72.836 66.47 63 88.5 63S121 72.978 121 85.99V108M88.5 55c10.216 0 18.5-8.06 18.5-18s-8.284-18-18.5-18S70 27.06 70 37s8.284 18 18.5 18z"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M38.509 54C48.18 54 56 46.164 56 36.509S48.164 19 38.509 19 21 26.836 21 36.509C21 46.18 28.836 54 38.509 54z"
    ></path>
    <path stroke="currentColor" strokeMiterlimit="10" strokeWidth="5" d="M72 88v20m33-20v20"></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M24 99v-8m-1-11h9m33-10.816c-3.45-4.54-8.934-6.732-16.291-7.184L38.18 70.332 27.653 62C14.147 62.835 7 69.48 7 85.867V99"
    ></path>
  </svg>
);

export default TwoDoctors;
